import React, { useState } from 'react';

import type { PopoverProps } from '@mui/material';

import { ColorSelectButton } from './ColorSelectButton';
import { ColorSelectMenu } from './ColorSelectMenu';

export type IconVariety = 'A' | 'marker' | 'fill' | 'line';
export type ColorSelectFunction = (e: React.MouseEvent, color: string | null) => void;
export const TRANSPARENT_HSLA = 'rgba(0, 0, 0, 0)';

interface ColorSelectComponentProps {
  defaultColorPalette: string[][];
  iconType: IconVariety;
  selectColor: ColorSelectFunction;
  selectedColor: string | null;
  tooltipTitle: string;
  disabled?: boolean;
  hasTransparentOption?: boolean;
}

export function ColorSelectComponent(props: ColorSelectComponentProps): JSX.Element {
  const {
    defaultColorPalette,
    disabled,
    hasTransparentOption,
    iconType,
    selectColor,
    selectedColor,
    tooltipTitle,
  } = props;
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<PopoverProps['anchorEl']>(null);

  function handleClose(): void {
    setMenuOpen(false);
  }

  function handleSelect(e: React.MouseEvent, color: string | null): void {
    selectColor(e, color);
    setMenuOpen(false);
  }

  return (
    <>
      <ColorSelectButton
        ref={setAnchorEl}
        disabled={disabled}
        iconType={iconType}
        menuOpen={menuOpen}
        selectedColor={selectedColor}
        setMenuOpen={setMenuOpen}
        tooltipTitle={tooltipTitle}
      />
      <ColorSelectMenu
        anchorEl={anchorEl}
        colorColumns={defaultColorPalette}
        handleClose={handleClose}
        hasTransparentOption={!!hasTransparentOption}
        open={menuOpen}
        selectColor={handleSelect}
        selectedColor={selectedColor}
      />
    </>
  );
}
